import * as i0 from '@angular/core';
import { Component, Input, Injectable, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

class DateTimeTranslations {
    constructor() {
        this.cancel = "Cancel";
        this.done = "Done";
    }
}

class DokaDateTimeComponent {
    constructor(modalC) {
        this.modalC = modalC;
        this.translations = new DateTimeTranslations();
    }
    deleteValue() {
        this.modalC.dismiss(null, undefined, "DokaDateTimeModal");
    }
    datetimeChanged(event) {
        this.modalC.dismiss(new Date(event.target.value.toString()).toISOString(), undefined, "DokaDateTimeModal");
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeComponent, deps: [{ token: i1.ModalController }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: DokaDateTimeComponent, selector: "app-date-picker", inputs: { translations: "translations" }, ngImport: i0, template: "<ion-datetime\r\n  id=\"datetime\"\r\n  presentation=\"date\"\r\n  (ionChange)=\"datetimeChanged($event)\"\r\n  #date\r\n>\r\n  <ion-buttons class=\"datetime-buttons\" slot=\"buttons\">\r\n    <ion-button color=\"primary\" (click)=\"deleteValue()\">\r\n      {{ translations.cancel }}\r\n    </ion-button>\r\n    <ion-button class=\"button-primary\" (click)=\"date.confirm()\">\r\n      {{ translations.done }}\r\n    </ion-button>\r\n  </ion-buttons>\r\n</ion-datetime>\r\n", styles: [".datePickerModal::part(content){width:fit-content;height:fit-content}\n"], dependencies: [{ kind: "component", type: i1.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "form", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { kind: "component", type: i1.IonButtons, selector: "ion-buttons", inputs: ["collapse"] }, { kind: "component", type: i1.IonDatetime, selector: "ion-datetime", inputs: ["cancelText", "clearText", "color", "dayValues", "disabled", "doneText", "firstDayOfWeek", "formatOptions", "highlightedDates", "hourCycle", "hourValues", "isDateEnabled", "locale", "max", "min", "minuteValues", "mode", "monthValues", "multiple", "name", "preferWheel", "presentation", "readonly", "showClearButton", "showDefaultButtons", "showDefaultTimeLabel", "showDefaultTitle", "size", "titleSelectedDatesFormatter", "value", "yearValues"] }, { kind: "directive", type: i1.SelectValueAccessor, selector: "ion-select, ion-radio-group, ion-segment, ion-datetime" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-date-picker', template: "<ion-datetime\r\n  id=\"datetime\"\r\n  presentation=\"date\"\r\n  (ionChange)=\"datetimeChanged($event)\"\r\n  #date\r\n>\r\n  <ion-buttons class=\"datetime-buttons\" slot=\"buttons\">\r\n    <ion-button color=\"primary\" (click)=\"deleteValue()\">\r\n      {{ translations.cancel }}\r\n    </ion-button>\r\n    <ion-button class=\"button-primary\" (click)=\"date.confirm()\">\r\n      {{ translations.done }}\r\n    </ion-button>\r\n  </ion-buttons>\r\n</ion-datetime>\r\n", styles: [".datePickerModal::part(content){width:fit-content;height:fit-content}\n"] }]
        }], ctorParameters: () => [{ type: i1.ModalController }], propDecorators: { translations: [{
                type: Input
            }] } });

class DokaDateTimeService {
    constructor(modalC) {
        this.modalC = modalC;
    }
    async open(translations = new DateTimeTranslations()) {
        const modal = await this.modalC.create({
            component: DokaDateTimeComponent,
            backdropDismiss: false,
            cssClass: "datePickerModal",
            id: "DokaDateTimeModal",
            componentProps: {
                translations: translations
            }
        });
        await modal.present();
        const res = await modal.onDidDismiss();
        return res.data;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeService, deps: [{ token: i1.ModalController }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.ModalController }] });

class DokaDateTimeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeModule, declarations: [DokaDateTimeComponent], imports: [CommonModule,
            FormsModule,
            IonicModule], exports: [DokaDateTimeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeModule, imports: [CommonModule,
            FormsModule,
            IonicModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaDateTimeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DokaDateTimeComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        IonicModule,
                    ],
                    exports: [
                        DokaDateTimeComponent,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/*
 * Public API Surface of doka-date-time
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DateTimeTranslations, DokaDateTimeComponent, DokaDateTimeModule, DokaDateTimeService };
